import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService, getResponse } from '../api.service';
import { Offer, OfferPackage, OfferProduct, ProductShort } from '@models';

@Injectable()
export class OfferService extends ApiService<Offer> {

    protected apiGroup: string = 'crm';
	protected apiName: string = 'offer';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	/**
	 * getPackages(parameters)
	 * Retrieve list of all products
	 */
	getPackages(offerId: number): Observable<getResponse<OfferPackage>> {
	   return this.http.get<getResponse<OfferPackage>>(
		   this.getBaseUrl('get_packages', offerId.toString())
	   ).retry(this.retries);
	}

	/**
	 * getProducts(parameters)
	 * Retrieve list of all products
	 */
	getProducts(offerId: number): Observable<getResponse<OfferProduct>> {
	   return this.http.get<getResponse<OfferProduct>>(
		   this.getBaseUrl('get_products', offerId.toString())
	   ).retry(this.retries);
	}

	updateProducts(offerId: number, products: (OfferProduct | OfferPackage)[]): Observable<getResponse<any>> {
		return this.http.post<getResponse<any>>(
			this.getBaseUrl('update_products', offerId.toString()),
			products
		).retry(this.retries);
	}

	loadProductShorts(): Observable<getResponse<ProductShort>> {
		return this.http.get<getResponse<ProductShort>>(
			this.getBaseUrl('load_shop_products')
		).retry(this.retries);
	}

	generatePDF(offerId: number): Observable<pdfResponse> {
		return this.http.get<pdfResponse>(
			this.getBaseUrl('generate_pdf', offerId.toString())
		);
	}

	getEmailTemplate(offerId: number, template: string): Observable<emailResponse> {
		return this.http.post<emailResponse>(
			this.getBaseUrl('get_email_template'),
			{
				offer_id: offerId,
				template: template
			}
		)
	}

	sendEmail(form: any): Observable<sendEmailResponse> {
		return this.http.post<sendEmailResponse>(
			this.getBaseUrl('send_email'),
			form
		)
	}
}

interface pdfResponse {
	success: boolean;
	pdf: string;
}

interface emailResponse {
	success: boolean;
	template: string;
	pdf: string;
}

interface sendEmailResponse {
	success: boolean
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/crm/offer.service.ts